import React, { useContext, useEffect, useState } from "react";
import * as Component from "../../../../component";
import styled from "styled-components";
import { COLOR_SECONDARY, ButtonPrimary, ButtonDanger } from "../../../../component/style/content/default";
import { api_transaksi } from "../../../../service/api";
import { Verified } from "@styled-icons/material-sharp";
import { Times } from "@styled-icons/typicons";
import { FormatCurrency, Moment } from "../../../../util";
import Alert from "sweetalert2";
import { Method } from "service";
import ModalFormFulfillment from "./modal.formFulfillment";
import * as Services from "../../../../service";
import moment from "moment";

const header = [
  "No",
  "Item",
  "Harga",
  "Qty",
  "Rating",
  "Subtotal"
];

const itemsPerPage = 10;
const SHIPPING_STATUS_DITOLAK = 8;
const SHIPPING_STATUS_CANCELLED = 11;
const DEFAULT_MANUAL_SEARCH_RETRY_THRESHOLD = 5;
const APPROVAL_STATUS_LABEL = {
  pending: "Pending",
  progressing: "Sedang Diproses",
  verified: "Terverifikasi",
  approved: "Disetujui",
  rejected: "Ditolak",
  failed: "Gagal",
  completed: "Selesai",
  payment_received: "Pembayaran Diterima",
	 scheduled: "Terjadwal",
  preparing_items: "Menyiapkan Barang",
  courier_process: "Proses Kurir"
};

const getApprovalStatusLabel = (status) => APPROVAL_STATUS_LABEL[normalizeText(status)] || status || "Pending";

const parseJsonSafely = (value, fallback = {}) => {
  if (!value) return fallback;
  if (typeof value === "object") return value;

  try {
    return JSON.parse(value);
  } catch (error) {
    return fallback;
  }
};

const normalizeText = (value) => `${value || ""}`.trim().toLowerCase();

const getShippingStatusId = (item = {}) => Number(item?.ms_shipping_status_id || item?.ms_shipping_status?.ms_shipping_status_id || 0);

const getPostPaymentAction = (transaction = {}) => {
  const transactionData = parseJsonSafely(transaction?.transaction_data, {});
  return parseJsonSafely(transactionData?.post_payment_action, {});
};

const getLatestShippingStatusId = (transaction = {}) => {
  const history = Array.isArray(transaction?.transaction_shipping_history) ? transaction.transaction_shipping_history : [];
  if (history.length === 0) return Number(transaction?.ms_shipping_status_id || 0);

  const latest = [...history].sort((a, b) => {
    const aTime = new Date(`${a?.created_at || a?.updated_at || 0}`.replace(" ", "T")).getTime();
    const bTime = new Date(`${b?.created_at || b?.updated_at || 0}`.replace(" ", "T")).getTime();
    if (Number.isFinite(aTime) && Number.isFinite(bTime) && aTime !== bTime) return bTime - aTime;

    return Number(b?.transaction_shipping_history_id || 0) - Number(a?.transaction_shipping_history_id || 0);
  })[0];

  return getShippingStatusId(latest) || Number(transaction?.ms_shipping_status_id || 0);
};

const isGosendTransaction = (transaction = {}) => {
  const shippingDetail = parseJsonSafely(transaction?.shipping_service_detail, {});
  const deliveryIdentifier = normalizeText(
    transaction?.ms_delivery?.ms_delivery_identifier ||
    transaction?.ms_delivery_identifier ||
    transaction?.delivery_identifier
  );

  return deliveryIdentifier === "gosend" || normalizeText(shippingDetail?.provider) === "gosend";
};

const isManualSearchFallbackStatus = (transaction = {}) => {
  const statusName = normalizeText(transaction?.transaction_approve_status_name);
  if (["rejected", "failed", "completed"].includes(statusName)) return false;
  if (["processing", "progressing", "approved"].includes(statusName)) return true;

  return [1, 3].includes(Number(transaction?.transaction_approve_status || 0));
};

const shouldShowManualSearchDriver = (transaction = {}) => {
	if (transaction?.marketplace_order_actions?.can_retry_courier !== undefined) return transaction.marketplace_order_actions.can_retry_courier === true;
  if (transaction?.can_manual_search_driver !== undefined && transaction?.can_manual_search_driver !== null) {
    return transaction.can_manual_search_driver === true;
  }

  const latestShippingStatusId = getLatestShippingStatusId(transaction);
  const postPaymentAction = getPostPaymentAction(transaction);
  const autoRetryCount = Number(transaction?.auto_retry_count || postPaymentAction?.gosend_auto_retry_count || 0);
  const retryThreshold = Number(transaction?.manual_search_driver_retry_threshold || DEFAULT_MANUAL_SEARCH_RETRY_THRESHOLD);
  const autoRetryLimitReached =
    Boolean(postPaymentAction?.gosend_auto_retry_limit_reached_at) ||
    autoRetryCount >= retryThreshold;

  return (
    isGosendTransaction(transaction) &&
    isManualSearchFallbackStatus(transaction) &&
    (
      latestShippingStatusId === SHIPPING_STATUS_DITOLAK ||
      (latestShippingStatusId === SHIPPING_STATUS_CANCELLED && autoRetryLimitReached)
    )
  );
};

const ModalTransaksiDetail = ({ show, onHide, transaction_id, onReload }) => {
  const { retail_permission } = useContext(Services.Context);
  const [data, setData] = useState({});
  const [page, setPage] = useState(1);
  const [modalFulfillment, setModalFulfillment] = useState(null);
  const [itemList, setItemList] = useState([]);
  const [shippingResi, setShippingResi] = useState('')
  const [manualSearchLoading, setManualSearchLoading] = useState(false);
  const [paymentUpdating, setPaymentUpdating] = useState(false);

  const getData = async () => {
    await Promise.all([
      api_transaksi.get_transaksi_detail({ transaction_id }).then((res) => {
        if (res?.success) {
          setData(res?.data);

          const transaction_data = JSON.parse(res.data.transaction_data);
          if (transaction_data.original_order) {
            setItemList(transaction_data.original_order.map(x => ({ transaction_detail_payload: x })))
          } else {
            setItemList(data.transaction_detail)
          }
        }
      })
    ]);
  };

  useEffect(() => {
    if (show) {
      getData();
    }
  }, [show]);

  const renderItem = () => {
    var item = itemList;
    const rates = data?.menu_rate
    if (item) {
      var content = [];
      for (var i = (page - 1) * itemsPerPage; i < ((page - 1) * itemsPerPage) + itemsPerPage; i++) {
        if (item[i]) {
          const rateData = rates?.find(rate => rate.item_id === item[i].transaction_detail_payload.item_id);
          content.push(
            <tr
              key={i}
            >
              <td data-label="No">{i + 1}</td>
              <td data-label="Item">{item[i].transaction_detail_payload.item_name}</td>
              <td data-label="Harga">{FormatCurrency.currency(item[i].transaction_detail_payload.current_price)}</td>
              <td data-label="Qty">{item[i].transaction_detail_payload.quantity}</td>
              <td data-label="Rating">{rateData ? rateData.rate : "N/A"}</td>
              <td data-label="Subtotal">{FormatCurrency.currency(item[i].transaction_detail_payload.current_price * item[i].transaction_detail_payload.quantity)}</td>
            </tr>
          )
        }
      }

      return content
    } else {
      return null
    }
  }

  const confirmPayment = async (type) => {
    await Alert.fire({
      title: type === 'approval' ? 'Konfirmasi Pembayaran' : 'Reject Pembayaran',
      input: 'textarea',
      inputAttributes: {
        placeholder: "Masukan note"
      },
      showCancelButton: true,
      confirmButtonText: type === 'approval' ? 'Konfirmasi' : 'Reject',
      showLoaderOnConfirm: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      preConfirm: (text) => {
        return Method
          .put(`transaction/${data.transaction_id}/${type}`, { transaction_status_note: text })
          .then((response) => {
            return response.data;
          })
          .catch((error) => {
            Alert.showValidationMessage(`Request failed`)
          });
      },
      allowOutsideClick: () => !Alert.isLoading()
    }).then((result) => {
      if (result.isConfirmed) {
        if (result.value.success) {
          Component.AlertSuccess({ title: "Success", text: result.value.success });
          getData();
          onReload();
        } else {
          Component.AlertError({ title: "Success", text: result.value.error });
        }
      }
    })
  }

  const checkDate = () => {
    const datetr = moment(data.transaction_created_datetime)
    const curr = moment(new Date())
    if (datetr.diff(curr, 'days') < 0) {
      return false
    } else {
      return true
    }
  }

  const dataShip = data?.shipping_service_detail ? JSON.parse(data?.shipping_service_detail) : null;
	const deliverySchedule = parseJsonSafely(data?.transaction_data, {})?.delivery_schedule || null;
	const scheduledDeliveryAt = deliverySchedule?.scheduled_at ? moment(deliverySchedule.scheduled_at) : null;

  const handleUpdateShippingStatus = async (transactionId, msShippingStatusId, shippingResi) => {
    const url = `/transaction/${transactionId}/shipping/status`;

    const formData = new FormData();
    formData.append('ms_shipping_status_id', msShippingStatusId);
    if (shippingResi) formData.append('shipping_resi', shippingResi);

    try {
      const response = await Method.put(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.data.success) {
        await Alert.fire("Success", response.data.success, "success");
        getData();
      } else {
        await Alert.fire("Error", response.data.error, "error");
      }
      return response.data;
    } catch (error) {
      Alert.fire("Error", "Something went wrong while updating shipping status.", "error");
    }
  };

  const handleUpdateStatusDikemas = async () => {
    const result = await Alert.fire({
      title: 'Are you sure?',
      text: "You are about to update the status to 'Dikemas'.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#6DB3E5',
      confirmButtonText: 'Yes, Update!',
      cancelButtonText: 'Cancel'
    });

    if (result.isConfirmed) {
      handleUpdateShippingStatus(data.transaction_id, 1, '');
    }
  };

  const handleUpdateStatusDikirim = async () => {
    const { value: resi } = await Alert.fire({
      title: 'Masukkan Nomor Resi',
      input: 'text',
      inputPlaceholder: 'Enter Shipping Resi',
      showCancelButton: true,
      confirmButtonText: 'Submit',
      confirmButtonColor: '#6DB3E5',
      preConfirm: (value) => {
        if (!value) {
          Alert.showValidationMessage('Please enter a valid shipping resi number.');
        }
      }
    });

    if (resi) {
      handleUpdateShippingStatus(data.transaction_id, 2, resi);
    }
  };

  const handleManualSearchDriver = async (retry = true) => {
    if (!data?.transaction_number || manualSearchLoading) return;

    const result = await Alert.fire({
      title: retry ? 'Cari Driver Ulang?' : 'Cari Driver?',
      text: retry ? 'Sistem akan melakukan pencarian driver GoSend ulang.' : 'Pastikan barang sudah siap sebelum mencari driver GoSend.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#6DB3E5',
      confirmButtonText: 'Cari Driver',
      cancelButtonText: 'Batal'
    });

    if (!result.isConfirmed) return;

    setManualSearchLoading(true);
    try {
      const response = data?.marketplace_order_actions?.eligible
        ? await Method.post(`transaction/${data.transaction_id}/marketplace-order/courier`, { retry })
        : await Method.post(`transaction/number/${data.transaction_number}/shipping/gosend/retry`, {});

      if (response.data.success) {
        await Alert.fire('Success', response.data.success, 'success');
        await getData();
        if (onReload) onReload();
      } else {
        await Alert.fire('Error', response.data.error || 'Pencarian driver manual gagal.', 'error');
      }
    } catch (error) {
      await Alert.fire('Error', error?.response?.data?.error || 'Pencarian driver manual gagal.', 'error');
    } finally {
      setManualSearchLoading(false);
    }
  };

  const handleUpdatePaymentStatus = async () => {
    const paymentDetail = data?.payment_status_detail;
    const latestAttempt = paymentDetail?.attempts?.[0];
    if (!paymentDetail?.can_update_manually || !latestAttempt || paymentUpdating) return;

    const result = await Alert.fire({
      title: 'Update Status Pembayaran',
      html: `
        <div style="text-align:left">
          <p>Status saat ini: <strong>${latestAttempt.normalized_status || '-'}</strong></p>
          <label for="manual-payment-status">Status baru</label>
          <select id="manual-payment-status" class="swal2-input" style="width:100%;margin:8px 0 16px 0">
            <option value="">Pilih status</option>
            <option value="SUCCESS">SUCCESS</option>
            <option value="FAILED">FAILED</option>
            <option value="EXPIRED">EXPIRED</option>
            <option value="CANCELED">CANCELED</option>
          </select>
          <label for="manual-payment-reason">Alasan verifikasi manual</label>
          <textarea id="manual-payment-reason" class="swal2-textarea" maxlength="500" style="width:100%;margin:8px 0 16px 0" placeholder="Minimal 5 karakter"></textarea>
          <label for="manual-payment-reference">Referensi tiket (opsional)</label>
          <input id="manual-payment-reference" class="swal2-input" maxlength="100" style="width:100%;margin:8px 0 0 0" placeholder="Contoh: OPS-123" />
          <p style="margin-top:16px;color:#b45309">Status SUCCESS akan melanjutkan proses transaksi dan pemesanan kurir.</p>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: 'Lanjutkan',
      cancelButtonText: 'Batal',
      confirmButtonColor: '#6DB3E5',
      preConfirm: () => {
        const popup = Alert.getPopup();
        const status = popup.querySelector('#manual-payment-status').value;
        const reason = popup.querySelector('#manual-payment-reason').value.trim();
        const provider_reference = popup.querySelector('#manual-payment-reference').value.trim();
        if (!status) return Alert.showValidationMessage('Status baru wajib dipilih.');
        if (reason.length < 5) return Alert.showValidationMessage('Alasan minimal 5 karakter.');
        return { status, reason, provider_reference: provider_reference || null };
      }
    });
    if (!result.isConfirmed) return;

    const confirmation = await Alert.fire({
      title: 'Konfirmasi perubahan?',
      text: result.value.status === 'SUCCESS'
        ? 'Pembayaran akan ditandai sukses dan proses pemesanan kurir akan dijalankan.'
        : `Pembayaran akan diubah menjadi ${result.value.status}.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ya, Update',
      cancelButtonText: 'Batal',
      confirmButtonColor: '#6DB3E5'
    });
    if (!confirmation.isConfirmed) return;

    setPaymentUpdating(true);
    try {
      const response = await api_transaksi.put_payment_status({
        transaction_id: data.transaction_id,
        body: { transaction_payment_id: latestAttempt.transaction_payment_id, ...result.value }
      });
      if (response?.success) {
        await Component.AlertSuccess({ title: 'Success', text: response.success });
        await getData();
        if (onReload) onReload();
      } else {
        await Component.AlertError({ title: 'Error', text: response?.error || 'Update status pembayaran gagal.' });
      }
    } catch (error) {
      await Component.AlertError({ title: 'Error', text: error?.response?.data?.error || 'Update status pembayaran gagal.' });
    } finally {
      setPaymentUpdating(false);
    }
  };

  const renderPaymentStatusDetail = () => {
    const paymentDetail = data?.payment_status_detail;
    if (!paymentDetail?.eligible) return null;
    const attempts = Array.isArray(paymentDetail.attempts) ? paymentDetail.attempts : [];
    const latestAttempt = attempts[0];
    const statusColor = latestAttempt?.normalized_status === 'SUCCESS'
      ? '#198754'
      : latestAttempt?.normalized_status === 'PENDING' ? '#b45309' : '#dc3545';
    const displayDate = value => value ? Moment(value) : '-';

    return (
      <div className="container mt-4">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h5 className="mb-0">Status Pembayaran Marketplace</h5>
          {paymentDetail.can_update_manually && (
            <ButtonPrimary disabled={paymentUpdating} onClick={handleUpdatePaymentStatus}>
              {paymentUpdating ? 'Memproses...' : 'Update Status Pembayaran'}
            </ButtonPrimary>
          )}
        </div>
        {latestAttempt && (
          <>
            <PaymentRow label="Gateway" value={latestAttempt.gateway_identifier} />
            <Row className="row bg-white">
              <div className="col-md-6 col-sm-6"><strong style={{ color: COLOR_SECONDARY }}>Status Pembayaran</strong></div>
              <div className="col-md-6 col-sm-6">
                <span style={{ color: '#fff', backgroundColor: statusColor, borderRadius: 12, padding: '3px 9px', fontSize: 12 }}>
                  {latestAttempt.normalized_status || '-'}
                </span>
                <span className="ms-2">{latestAttempt.status || '-'} ({latestAttempt.status_code || '-'})</span>
              </div>
            </Row>
            <PaymentRow label="Pesan" value={latestAttempt.message} />
            <PaymentRow label="Payment / Transaction ID" value={latestAttempt.provider_transaction_id} />
            <PaymentRow label="Order / Reference ID" value={latestAttempt.provider_order_id} />
            <PaymentRow label="Request ID" value={latestAttempt.provider_request_id} />
            <PaymentRow label="Jenis Pembayaran" value={latestAttempt.type} />
            <PaymentRow label="Waktu Transaksi" value={displayDate(latestAttempt.transaction_datetime)} />
            <PaymentRow label="Waktu Settlement" value={displayDate(latestAttempt.settlement_datetime)} />
            <PaymentRow label="Kedaluwarsa" value={displayDate(latestAttempt.expires_at)} />
            {latestAttempt.last_manual_update && (
              <Row className="row bg-white">
                <div className="col-md-6 col-sm-6"><strong style={{ color: COLOR_SECONDARY }}>Update Manual Terakhir</strong></div>
                <div className="col-md-6 col-sm-6">
                  <div>{displayDate(latestAttempt.last_manual_update.created_at)} — {latestAttempt.last_manual_update.reason}</div>
                  <small>User #{latestAttempt.last_manual_update.created_by_user_id}; proses lanjutan: {latestAttempt.last_manual_update.post_process_status}</small>
                </div>
              </Row>
            )}
          </>
        )}
        {attempts.length > 1 && (
          <details className="mt-3">
            <summary style={{ cursor: 'pointer', color: COLOR_SECONDARY }}>Riwayat attempt pembayaran ({attempts.length})</summary>
            <div className="mt-2">
              {attempts.map((attempt, index) => (
                <div key={attempt.transaction_payment_id} className="border rounded p-2 mb-2 bg-white">
                  <strong>Attempt #{attempt.transaction_payment_id}{index === 0 ? ' (terbaru)' : ''}</strong>
                  <div>{attempt.gateway_identifier || '-'} — {attempt.normalized_status || '-'} / {attempt.status || '-'}</div>
                  <div className="text-break">Order: {attempt.provider_order_id || '-'} | Payment: {attempt.provider_transaction_id || '-'}</div>
                  <div>Waktu: {displayDate(attempt.transaction_datetime)}</div>
                </div>
              ))}
            </div>
          </details>
        )}
      </div>
    );
  };

  return (
    <Component.Modal_Component show={show} onHide={onHide} title="Detail Transaksi">
      {
        modalFulfillment ? (
          <ModalFormFulfillment
            show={modalFulfillment}
            onHide={() => setModalFulfillment(null)}
            onSubmit={() => {
              getData();
              setModalFulfillment(null);
              onReload();
            }}
          />
        ) : (
          <div>
            {
              data.transaction_approve_status_name === "pending" &&
              <div className="d-flex flex-row">
                <ButtonPrimary onClick={() => confirmPayment('approval')}>
                  Konfirmasi Pembayaran
                </ButtonPrimary>
                <ButtonDanger className="ms-2" onClick={() => confirmPayment('reject')}>
                  Reject Pembayaran
                </ButtonDanger>
              </div>
            }

            {
              data.transaction_approve_status_name === "approved" &&
              <div className="d-flex flex-row">
                <ButtonPrimary
                  onClick={() => setModalFulfillment(data)}
                >
                  Fulfillment
                </ButtonPrimary>
                {
                  (retail_permission.data === null || retail_permission.data?.type === 'owner') &&
                  <ButtonDanger
                    className="ms-2"
                    onClick={() => confirmPayment('reject')}
                  >
                    Void
                  </ButtonDanger>
                }
              </div>
            }

            <div className="container mt-3">
              <Row className="row bg-white">
                <div className="col-md-6 col-sm-6">
                  <strong style={{ color: COLOR_SECONDARY }}>Toko</strong>
                </div>
                <div className="col-md-6 col-sm-6">{data?.store?.store_name}</div>
              </Row>
              <Row className="row bg-white">
                <div className="col-md-6 col-sm-6">
                  <strong style={{ color: COLOR_SECONDARY }}>Nomor Transaksi</strong>
                </div>
                <div className="col-md-6 col-sm-6">{data.transaction_id}</div>
              </Row>
              <Row className="row bg-white">
                <div className="col-md-6 col-sm-6">
                  <strong style={{ color: COLOR_SECONDARY }}>
                    Status Persetujuan
                  </strong>
                </div>
                <div className="col-md-6 col-sm-6">
                  {data.transaction_approve_status_name === "approved" ? (
                    <><Verified style={{ width: "25px", color: "#04D010" }} /> {getApprovalStatusLabel(data.transaction_approve_status_name)}</>
                  ) : data.transaction_approve_status_name === "rejected" ? (
                    <><Times style={{ width: "25px", color: "red" }} /> {getApprovalStatusLabel(data.transaction_approve_status_name)}</>
                  ) : (
                    getApprovalStatusLabel(data.transaction_approve_status_name)
                  )}
                </div>
              </Row>
              <Row className="row bg-white">
                <div className="col-md-6 col-sm-6">
                  <strong style={{ color: COLOR_SECONDARY }}>Tipe Transaksi</strong>
                </div>
                <div className="col-md-6 col-sm-6">
                  {data.ms_transaction && data.ms_transaction.ms_transaction_name}
                </div>
              </Row>
              <Row className="row bg-white">
                <div className="col-md-6 col-sm-6">
                  <strong style={{ color: COLOR_SECONDARY }}>Jumlah Transaksi</strong>
                </div>
                <div className="col-md-6 col-sm-6">
                  {FormatCurrency.currency(data.transaction_amount)}
                </div>
              </Row>
              <Row className="row bg-white">
                <div className="col-md-6 col-sm-6">
                  <strong style={{ color: COLOR_SECONDARY }}>Pajak</strong>
                </div>
                <div className="col-md-6 col-sm-6">
                  {FormatCurrency.currency(data.transaction_tax)}
                </div>
              </Row>
              <Row className="row bg-white">
                <div className="col-md-6 col-sm-6">
                  <strong style={{ color: COLOR_SECONDARY }}>Diskon</strong>
                </div>
                <div className="col-md-6 col-sm-6">
                  {FormatCurrency.currency(data.transaction_discount)}
                </div>
              </Row>
              <Row className="row bg-white">
                <div className="col-md-6 col-sm-6">
                  <strong style={{ color: COLOR_SECONDARY }}>
                    Biaya Administrasi
                  </strong>
                </div>
                <div className="col-md-6 col-sm-6">
                  {FormatCurrency.currency(data.transaction_administration_fee)}
                </div>
              </Row>
              <Row className="row bg-white">
                <div className="col-md-6 col-sm-6">
                  <strong style={{ color: COLOR_SECONDARY }}>
                    Jumlah Total Transaksi
                  </strong>
                </div>
                <div className="col-md-6 col-sm-6">
                  {FormatCurrency.currency(data.transaction_total_amount)}
                </div>
              </Row>
              <Row className="row bg-white">
                <div className="col-md-6 col-sm-6">
                  <strong style={{ color: COLOR_SECONDARY }}>
                    Metode Pembayaran
                  </strong>
                </div>
                <div className="col-md-6 col-sm-6">
                  {data.ms_payment && data.ms_payment.ms_payment_name}
                </div>
              </Row>
              {
                data?.ms_payment?.ms_payment_bank_recipient_number &&
                <Row className="row bg-white">
                  <div className="col-md-6 col-sm-6">
                    <strong style={{ color: COLOR_SECONDARY }}>Nomor Rekening</strong>
                  </div>
                  <div className="col-md-6 col-sm-6">
                    {data.ms_payment.ms_payment_bank_recipient_number}
                  </div>
                </Row>
              }
              <Row className="row bg-white">
                <div className="col-md-6 col-sm-6">
                  <strong style={{ color: COLOR_SECONDARY }}>Tanggal Dibuat</strong>
                </div>
                <div className="col-md-6 col-sm-6">
                  {Moment(data.transaction_created_datetime)}
                </div>
              </Row>
              <Row className="row bg-white">
                <div className="col-md-6 col-sm-6">
                  <strong style={{ color: COLOR_SECONDARY }}>Dibuat Oleh</strong>
                </div>
                <div className="col-md-6 col-sm-6">
                  {data.transaction_created_by && data.transaction_created_by.name}
                </div>
              </Row>
              {
                data.transaction_updated_datetime &&
                <Row className="row bg-white">
                  <div className="col-md-6 col-sm-6">
                    <strong style={{ color: COLOR_SECONDARY }}>Tanggal Diubah</strong>
                  </div>
                  <div className="col-md-6 col-sm-6">
                    {data.transaction_updated_datetime &&
                      Moment(data.transaction_updated_datetime)}
                  </div>
                </Row>
              }
              {
                data.transaction_updated_by &&
                <Row className="row bg-white">
                  <div className="col-md-6 col-sm-6">
                    <strong style={{ color: COLOR_SECONDARY }}>Diubah Oleh</strong>
                  </div>
                  <div className="col-md-6 col-sm-6">
                    {data.transaction_updated_by && data.transaction_updated_by.name}
                  </div>
                </Row>
              }
            </div>

            {renderPaymentStatusDetail()}

            <div className="container mt-4">
              <Row className="row bg-white">
                <div className="col-md-6 col-sm-6">
                  <strong style={{ color: COLOR_SECONDARY }}>Nama Customer</strong>
                </div>
                <div className="col-md-6 col-sm-6">{data.customer_name}</div>
              </Row>
              <Row className="row bg-white">
                <div className="col-md-6 col-sm-6">
                  <strong style={{ color: COLOR_SECONDARY }}>Phone Customer</strong>
                </div>
                <div className="col-md-6 col-sm-6">{data.customer_msisdn}</div>
              </Row>
              <Row className="row bg-white">
                <div className="col-md-6 col-sm-6">
                  <strong style={{ color: COLOR_SECONDARY }}>Delivery</strong>
                </div>
                <div className="col-md-6 col-sm-6">{data.ms_delivery?.ms_delivery_name}</div>
              </Row>
              <Row className="row bg-white">
                <div className="col-md-6 col-sm-6">
                  <strong style={{ color: COLOR_SECONDARY }}>Tanggal Request Delivery</strong>
                </div>
                <div className="col-md-6 col-sm-6">{Moment(data?.transaction_delivery_expected_datetime ? data?.transaction_delivery_expected_datetime : '-')}</div>
              </Row>
								{scheduledDeliveryAt?.isValid?.() && <>
									<Row className="row bg-white">
										<div className="col-md-6 col-sm-6"><strong style={{ color: COLOR_SECONDARY }}>Jadwal Pengiriman</strong></div>
										<div className="col-md-6 col-sm-6">{scheduledDeliveryAt.format('DD MMMM YYYY')}</div>
									</Row>
									<Row className="row bg-white">
										<div className="col-md-6 col-sm-6"><strong style={{ color: COLOR_SECONDARY }}>Jam Pengiriman</strong></div>
										<div className="col-md-6 col-sm-6">{scheduledDeliveryAt.format('HH:mm')}</div>
									</Row>
								</>}
              {
                data.cashier &&
                <Row className="row bg-white">
                  <div className="col-md-6 col-sm-6">
                    <strong style={{ color: COLOR_SECONDARY }}>Kasir</strong>
                  </div>
                  <div className="col-md-6 col-sm-6">{data.cashier.cashier_name}</div>
                </Row>
              }
            </div>

            <div className="container mt-4">
              <Row className="row bg-white">
                <div className="col-md-6 col-sm-6">
                  <strong style={{ color: COLOR_SECONDARY }}>Status Pengiriman</strong>
                </div>
                <div className="col-md-6 col-sm-6">{data?.ms_shipping_status?.ms_shipping_status_name}</div>
              </Row>
              <Row className="row bg-white">
                <div className="col-md-6 col-sm-6">
                  <strong style={{ color: COLOR_SECONDARY }}>Ekspedisi</strong>
                </div>
                <div className="col-md-6 col-sm-6">{dataShip?.expedition?.name}</div>
              </Row>
              <Row className="row bg-white">
                <div className="col-md-6 col-sm-6">
                  <strong style={{ color: COLOR_SECONDARY }}>Biaya Kirim</strong>
                </div>
                <div className="col-md-6 col-sm-6">{FormatCurrency.currency(data.transaction_shipping_fee)}</div>
              </Row>
              <Row className="row bg-white">
                <div className="col-md-6 col-sm-6">
                  <strong style={{ color: COLOR_SECONDARY }}>Estimasi</strong>
                </div>
                <div className="col-md-6 col-sm-6">{dataShip?.expedition?.service?.cost?.etd} day</div>
              </Row>
              <Row className="row bg-white">
                <div className="col-md-6 col-sm-6 d-flex align-items-center">
                  <strong style={{ color: COLOR_SECONDARY }}>Alamat Pengiriman</strong>
                </div>
                <div className="col-md-6 col-sm-6">{data.shipping_destination_address}</div>
              </Row>
              <Row className="row bg-white">
                <div className="col-md-6 col-sm-6">
                  <strong style={{ color: COLOR_SECONDARY }}>Pengiriman</strong>
                </div>
                <div className="col-md-6 col-sm-6">{dataShip?.origin_details?.city_name} ke {dataShip?.destination_details?.city_name}</div>
              </Row>
              <Row className="row bg-white">
                <div className="col-md-6 col-sm-6">
                  <strong style={{ color: COLOR_SECONDARY }}>No. Resi</strong>
                </div>
                <div className="col-md-6 col-sm-6">{data.shipping_resi}</div>
              </Row>
              <Row className="row bg-white">
                <div className="col-md-6 col-sm-6 d-flex align-items-center">
                  <strong style={{ color: COLOR_SECONDARY }}>History Transaksi</strong>
                </div>
                <div className="col-md-6 col-sm-6">
                  {data?.transaction_shipping_history?.map((item, index) => (
                    <div key={index}>
                      {Moment(item?.created_at)} - {item?.ms_shipping_status?.ms_shipping_status_name}
                    </div>
                  ))}
                </div>
              </Row>
            </div>

            {data?.marketplace_order_actions?.can_request_courier === true && (
              <div className="mt-4">
                <ButtonPrimary disabled={manualSearchLoading} onClick={() => handleManualSearchDriver(false)}>
                  {manualSearchLoading ? 'Mencari...' : 'Cari Driver'}
                </ButtonPrimary>
              </div>
            )}

            {shouldShowManualSearchDriver(data) && (
              <div className="mt-4">
                <ButtonPrimary disabled={manualSearchLoading} onClick={() => handleManualSearchDriver(true)}>
                  {manualSearchLoading ? 'Mencari...' : 'Cari Driver Ulang'}
                </ButtonPrimary>
              </div>
            )}

            {data.ms_delivery_id === 2 && data.transaction_approve_status_name === "approved" && data.ms_shipping_status_id !== 2 && (
              <div className="mt-4">
                {data?.ms_shipping_status_id !== 1 && (
                  <ButtonPrimary onClick={handleUpdateStatusDikemas}>Dikemas</ButtonPrimary>
                )}
                {data?.ms_shipping_status_id === 1 && (
                  <ButtonPrimary onClick={handleUpdateStatusDikirim}>Dikirim</ButtonPrimary>
                )}
              </div>
            )}

            {
              data.ms_merchant_payment &&
              <div className="container mt-4">
                <Row className="row bg-white">
                  <div className="col-md-6 col-sm-6">
                    <strong style={{ color: COLOR_SECONDARY }}>Merchant</strong>
                  </div>
                  <div className="col-md-6 col-sm-6">{data.ms_merchant_payment.ms_merchant_payment_name}</div>
                </Row>
                {
                  data.online_order_date &&
                  <Row className="row bg-white">
                    <div className="col-md-6 col-sm-6">
                      <strong style={{ color: COLOR_SECONDARY }}>Tanggal Order Online</strong>
                    </div>
                    <div className="col-md-6 col-sm-6">{Moment(data.online_order_date)}</div>
                  </Row>  
                }
                {
                  data.transaction_receipt_number &&
                  <Row className="row bg-white">
                    <div className="col-md-6 col-sm-6">
                      <strong style={{ color: COLOR_SECONDARY }}>Kode Pembayaran</strong>
                    </div>
                    <div className="col-md-6 col-sm-6">{data.transaction_receipt_number}</div>
                  </Row>
                }
                {
                  data.transaction_delivery_fulfilled_datetime &&
                  <Row className="row bg-white">
                    <div className="col-md-6 col-sm-6">
                      <strong style={{ color: COLOR_SECONDARY }}>Tanggal Fulfill Delivery</strong>
                    </div>
                    <div className="col-md-6 col-sm-6">{Moment(data.transaction_delivery_fulfilled_datetime)}</div>
                  </Row>
                }
                {
                  data.transaction_delivery_note &&
                  <Row className="row bg-white">
                    <div className="col-md-6 col-sm-6">
                      <strong style={{ color: COLOR_SECONDARY }}>Note</strong>
                    </div>
                    <div className="col-md-6 col-sm-6">{data.transaction_delivery_note}</div>
                  </Row>
                }
              </div>
            }
            <div className="mt-4">
              <h5 className="mb-2">Item</h5>
              <div style={{ backgroundColor: '#fff' }}>
                <Component.TableData header={header}>
                  {renderItem()}
                </Component.TableData>
                {
                  data?.transaction_detail?.length > 0 &&
                  <div className="pb-2 pt-2">
                    <Component.Pagination
                      page={page}
                      totalPage={Math.ceil(data?.transaction_detail?.length / itemsPerPage)}
                      handleOnChange={(e) => setPage(e.selected + 1)}
                    />
                  </div>
                }
              </div>
            </div>
          </div>
        )
      }
    </Component.Modal_Component>
  );
};

const PaymentRow = ({ label, value }) => (
  <Row className="row bg-white">
    <div className="col-md-6 col-sm-6">
      <strong style={{ color: COLOR_SECONDARY }}>{label}</strong>
    </div>
    <div className="col-md-6 col-sm-6 text-break">{value || '-'}</div>
  </Row>
);

const Row = styled.div`
  border: 1px solid transparent;
  border-bottom-color: #ccc;
  padding: 5px 5px;

  &:last-child {
    border-bottom-color: transparent;
  }
`;

export default ModalTransaksiDetail;
